import { createContext } from 'preact/compat';
export const optionDefaults = {
    membershipCategories: [],
    membershipTypes: [],
    introductionTitle: 'Join Now',
    introductionCopy: 'It’s real simple, just answer a few questions!',
    durations: undefined,
    paymentIcon: undefined,
    paymentTag: undefined,
    paymentQuestion: 'Pick your membership',
    paymentQuestionCopy: undefined,
    paymentTypes: undefined,
    membershipIcon: 'fitness',
    membershipTag: 'Fitness Membership',
    membershipQuestion: 'Pick your membership',
    membershipQuestionCopy: undefined,
    memberModalTitle: 'Almost there!',
    submissionUrl: 'membership-terms.html',
    loggedIn: false,
    showPaymentType: true,
};
export const FitnessFormOptionsCTX = createContext(optionDefaults);
